module.exports = __webpack_public_path__ + "static/media/struts-struts-red.b8866764.svg";